import axios from 'axios';

export const logError = (error: Error) => {
  const message = [
    'URL: ' + window.location.href,
    'Message: ' + error.message,
    'Stack: ' + error.stack,
  ].join(' - ');

  axios('/logs/clienterror', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    data: JSON.stringify({ message }),
  });
};
